import { DependencyList, useEffect, useState } from 'react';
import { IDrillSelection } from './drill-down-drawer';

/**
 * Local state for a chart drill-down drawer: what is selected, and the handlers to open/close it.
 * A selection with no entity id is ignored (an aggregate "Other" mark, or a not-yet-resolved id,
 * cannot be drilled). Pass the values the drawer reads (report period, basis, comparison period) as
 * `resetDeps` so a stale selection clears when the data underneath it changes.
 */
export function useDrillDown(resetDeps: DependencyList = []) {
  const [selection, setSelection] = useState<IDrillSelection | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setSelection(null); }, resetDeps);

  const openDrill = (sel: IDrillSelection | null) => {
    if (!sel || !sel.id) return;
    setSelection(sel);
  };
  const close = () => setSelection(null);

  return { selection, open: !!selection, openDrill, close };
}
